const fieldAttributes = {
  is_unique: { type: "boolean" },
  // default_email: { type: "boolean" }, Don't pass because we need to allow different email ids to be saved in dummy data creation
  format: { type: "string" },
  options: {
    type: "array",
    items: {
      type: "string",
    },
  },
  source_sheet_name: { type: "string" },
  source_column_name: { type: "string" },
  subsheet_fields: {
    type: "array",
    items: {
      type: "object",
      properties: {
        field_name: {
          type: "string",
        },
        attributes: {
          type: "object",
          enum: ["is_unique", "default_email", "format", "options"],
        },
        field_type_id: {
          type: "number",
        },
      },
      required: ["field_name", "attributes", "field_type_id"],
    },
  },
  formula: {
    type: "string",
  },
  formula_type: {
    type: "string",
    enum: ["date", "text", "number", "currency"],
  },
};

const chatFunctions = [
  {
    name: "createSheet",
    description:
      "Creates a sheet/table/schema along with its fields and required attributes.",
    parameters: {
      type: "object",
      properties: {
        packName: {
          type: "string",
          description: "Name of the new pack into which sheet will be added.",
        },
        sheetName: {
          type: "string",
          description: "Name of the sheet table or schema",
        },
        singularNameOfSheet: {
          type: "string",
          description: "Singular name of the sheet",
        },
        fields: {
          type: "array",
          items: {
            type: "object",
            properties: {
              field_name: {
                type: "string",
                description: "Name of the field or column",
              },
              attributes: {
                type: "object",
                properties: fieldAttributes,
                description: "Attributes for respective field type",
              },
              field_type_id: {
                type: "number",
                description: "Corresponding field type ID.",
              },
              subsheet_fields: {
                type: "array",
                description: "List of Fields of a subsheet.",
                items: {
                  type: "object",
                  properties: {
                    field_name: {
                      type: "string",
                      description: "Name of the field or column for subsheet",
                    },
                    attributes: {
                      type: "object",
                      properties: fieldAttributes,
                      description:
                        "is_unique, default_email, format, options, only recommended field Attributes for subsheet",
                      enum: ["is_unique", "default_email", "format", "options"],
                    },
                    field_type_id: {
                      type: "number",
                      description: "Corresponding field type ID for subsheet",
                    },
                  },
                  required: ["field_name", "attributes", "field_type_id"],
                },
              },
            },
            required: [
              "field_name",
              "attributes",
              "field_type_id",
              "subsheet_fields",
            ],
          },
          description:
            "Array of field with required field attributes and field information",
        },
      },
      required: ["packName", "sheetName", "singularNameOfSheet", "fields"],
    },
  },
  {
    name: "createSheets",
    description: "Creates multiple sheets",
    parameters: {
      type: "object",
      properties: {
        packName: {
          type: "string",
          description: "Name of the pack into which sheet will be added",
        },
        packId: {
          type: "number",
          description:
            "ID of the pack if sheet has to be added in existing pack.",
        },
        sheets: {
          type: "array",
          description: "Array of sheets",
          items: {
            type: "object",
            properties: {
              sheetName: {
                type: "string",
                description: "Name of sheet table or schema",
              },
              singularNameOfSheet: {
                type: "string",
                description: "Singular name of the sheet",
              },
              fields: {
                type: "array",
                items: {
                  type: "object",
                  properties: {
                    field_name: {
                      type: "string",
                      description: "Name of field or column",
                    },
                    attributes: {
                      type: "object",
                      properties: fieldAttributes,
                      description: "attributes for respective field type",
                    },
                    field_type_id: {
                      type: "number",
                      description: "Corresponding field type id",
                    },
                  },
                  required: ["field_name", "attributes", "field_type_id"],
                },
                description:
                  "array of field with required field attributes and field information",
              },
            },
            required: ["sheetName", "singularNameOfSheet", "fields"],
          },
        },
      },
      required: ["sheets", "packName"],
    },
  },
  {
    name: "addColumnsToASheet",
    description: "Adds multiple columns to a sheet",
    parameters: {
      type: "object",
      properties: {
        sheetId: {
          type: "number",
          description: "ID of the sheet, table or schema",
        },
        sheetName: {
          type: "string",
          description: "Current name of the sheet",
        },
        newSheetName: {
          type: "string",
          description: "New name of the sheet, if sheet name is to be changed",
        },
        packId: {
          type: "number",
          description: "ID of the pack to which the sheet belong.",
        },
        fields: {
          type: "array",
          items: {
            type: "object",
            properties: {
              field_name: {
                type: "string",
                description: "Name of the field or column",
              },
              attributes: {
                type: "object",
                properties: fieldAttributes,
                description: "Attributes for respective field type",
              },
              field_type_id: {
                type: "number",
                description: "Corresponding field type ID.",
              },
              subsheet_fields: {
                type: "array",
                description: "List of Fields of a subsheet.",
                items: {
                  type: "object",
                  properties: {
                    field_name: {
                      type: "string",
                      description: "Name of the field or column for subsheet",
                    },
                    attributes: {
                      type: "object",
                      properties: fieldAttributes,
                      description:
                        "is_unique, default_email, format, options, only recommended field Attributes for subsheet",
                      enum: ["is_unique", "default_email", "format", "options"],
                    },
                    field_type_id: {
                      type: "number",
                      description: "Corresponding field type ID for subsheet",
                    },
                  },
                  required: [
                    "field_name",
                    "attributes",
                    "field_type_id",
                    "subsheet_fields",
                  ],
                },
              },
            },
            required: ["field_name", "attributes", "field_type_id"],
          },
          description:
            "Array of field with required field attributes and field information",
        },
      },
      required: ["sheetId", "sheetName", "newSheetName", "packId", "fields"],
    },
  },
  {
    name: "shareSheet",
    description: "share the sheet to a group, selected users etc.",
    parameters: {
      type: "object",
      properties: {
        sheetId: {
          type: "number",
          description: "ID of the sheet, table or schema",
        },
        role: {
          description:
            "The sheet will be shared in this group. Default group is Standard Users.",
          type: "string",
          // items: {
          //   type: "string",
          //   enum: ["adminUsers", "standardUsers"],
          // },
          emun: ["Admin Users", "Standard Users"],
        },
        emails: {
          description:
            "Emails of the users to which the sheet has to be shared.",
          type: "array",
          items: {
            type: "string",
          },
        },
      },
      required: ["sheetId", "role", "emails"],
    },
  },
];

export default chatFunctions;
